import React from "react"
import { useNavigate } from "react-router-dom"

const BackButton = () => {
  const navigate = useNavigate()

  const goBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1)
    } else {
      navigate("/dashboard")
    }
  }

  return (
    <i
      className="bx bx-arrow-back me-1 fs-5 cursor-pointer"
      onClick={goBack}
    ></i>
  )
}

export default BackButton
